import {ImageItem} from "../image-item";

export class TextItem {

    MAX_STRING_LENGTH = 50;
    MAX_ROW_LENGTH = 3;

    isSelected: boolean;
    time: number;
    text: string;
    textFormated: string;
    image: ImageItem;
    id: number;

    getTimeAsString() {
        if (typeof this.time === 'number') {
            const minutes: number = Math.floor(this.time / 60);
            const seconds: number = Math.round(this.time - minutes * 60);
            return minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);
        }
    }

    getAudioPointText() {
        return '    ' + this.text.match(new RegExp('.{1,' + this.MAX_STRING_LENGTH + '}', 'g'))
            .slice(0, this.MAX_ROW_LENGTH).join('\n    ');
    }

}
